<p-drawer [(visible)]="visible" position="right" [style]="{ width: '45rem' }" [modal]="true" (onHide)="hide()" appendTo="body">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{ item?.id ? 'Editar Equipo' : 'Nuevo Equipo' }}</span>
    </ng-template>

    <ng-template pTemplate="content">
        <form [formGroup]="equipmentForm" class="p-2">
            <!-- Section 1: General Info -->
            <div class="mb-5">
                <h3 class="text-900 font-medium mb-3 border-bottom-1 surface-border pb-2 flex align-items-center">
                    <i class="pi pi-info-circle mr-2 text-blue-500"></i>Información General
                </h3>
                <div class="grid">
                    <div class="col-12 md:col-6 mb-3">
                        <label for="equipment_code" class="block text-900 font-medium mb-2">Código de Equipo</label>
                        <input pInputText id="equipment_code" formControlName="equipment_code" class="w-full" placeholder="Autogenerado si se deja vacío" />
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="name" class="block text-900 font-medium mb-2">Nombre del Equipo *</label>
                        <input pInputText id="name" formControlName="name" class="w-full" placeholder="Ej: Espectrofotómetro UV-Vis" />
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="brandId" class="block text-900 font-medium mb-2">Marca</label>
                        <p-select id="brandId" [options]="brands()" formControlName="brandId" optionLabel="name" optionValue="id" [filter]="true" class="w-full" appendTo="body" placeholder="Seleccione una marca"></p-select>
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="model" class="block text-900 font-medium mb-2">Modelo *</label>
                        <input pInputText id="model" formControlName="model" class="w-full" placeholder="Ej: GENESYS 50" />
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="serial_number" class="block text-900 font-medium mb-2">Número de Serie</label>
                        <input pInputText id="serial_number" formControlName="serial_number" class="w-full" placeholder="Ej: SN-123456" />
                    </div>
                    <div class="col-12 mb-3">
                        <label for="description" class="block text-900 font-medium mb-2">Descripción</label>
                        <textarea pInputTextarea id="description" formControlName="description" rows="2" class="w-full" placeholder="Detalles adicionales del equipo..."></textarea>
                    </div>
                </div>
            </div>

            <!-- Section 2: Acquisition & Context -->
            <div class="mb-5">
                <h3 class="text-900 font-medium mb-3 border-bottom-1 surface-border pb-2 flex align-items-center">
                    <i class="pi pi-shopping-bag mr-2 text-blue-500"></i>Contexto y Adquisición
                </h3>
                <div class="grid">
                    <div class="col-12 md:col-6 mb-3">
                        <label for="vendorId" class="block text-900 font-medium mb-2">Proveedor</label>
                        <p-select id="vendorId" [options]="vendors()" formControlName="vendorId" optionLabel="name" optionValue="id" [filter]="true" class="w-full" appendTo="body" placeholder="Seleccione un proveedor"></p-select>
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="locationId" class="block text-900 font-medium mb-2">Ubicación</label>
                        <p-select id="locationId" [options]="locations()" formControlName="locationId" optionLabel="name" optionValue="id" [filter]="true" class="w-full" appendTo="body" placeholder="Seleccione ubicación"></p-select>
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="purchase_date" class="block text-900 font-medium mb-2">Fecha de Compra</label>
                        <p-datepicker id="purchase_date" formControlName="purchase_date" class="w-full" appendTo="body" [showIcon]="true" dateFormat="dd/mm/yy"></p-datepicker>
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="acceptance_date" class="block text-900 font-medium mb-2">Fecha Ingreso Lab.</label>
                        <p-datepicker id="acceptance_date" formControlName="acceptance_date" class="w-full" appendTo="body" [showIcon]="true" dateFormat="dd/mm/yy"></p-datepicker>
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="warranty_expiration" class="block text-900 font-medium mb-2">Expiración Garantía</label>
                        <p-datepicker id="warranty_expiration" formControlName="warranty_expiration" class="w-full" appendTo="body" [showIcon]="true" dateFormat="dd/mm/yy"></p-datepicker>
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="responsible_user_id" class="block text-900 font-medium mb-2">Usuario Responsable</label>
                        <p-select id="responsible_user_id" [options]="users()" formControlName="responsible_user_id" optionLabel="fullName" optionValue="user" [filter]="true" class="w-full" appendTo="body" placeholder="Seleccione responsable"></p-select>
                    </div>
                    <div class="col-12 mb-3">
                        <label for="condition_on_arrival" class="block text-900 font-medium mb-2">Condición al Ingresar</label>
                        <input pInputText id="condition_on_arrival" formControlName="condition_on_arrival" class="w-full" placeholder="Ej: Nuevo en caja, con manuales" />
                    </div>
                </div>
            </div>

            <!-- Section 3: Lifecycle -->
            <div class="mb-4">
                <h3 class="text-900 font-medium mb-3 border-bottom-1 surface-border pb-2 flex align-items-center">
                    <i class="pi pi-calendar-clock mr-2 text-blue-500"></i>Mantenimiento y Ciclo de Vida
                </h3>
                <div class="grid">
                    <div class="col-12 md:col-6 mb-3">
                        <label for="calibration_period_days" class="block text-900 font-medium mb-2">Período Calibración (Días)</label>
                        <p-inputnumber id="calibration_period_days" formControlName="calibration_period_days" class="w-full" [showButtons]="true" [min]="0" placeholder="Ej: 365"></p-inputnumber>
                    </div>
                    <div class="col-12 md:col-6 mb-3">
                        <label for="maintenance_period_days" class="block text-900 font-medium mb-2">Período Mantenimiento (Días)</label>
                        <p-inputnumber id="maintenance_period_days" formControlName="maintenance_period_days" class="w-full" [showButtons]="true" [min]="0" placeholder="Ej: 180"></p-inputnumber>
                    </div>
                    <div class="col-12">
                        <div class="p-3 border-round-xl surface-50 border-1 border-blue-200 flex gap-3 align-items-start">
                            <i class="pi pi-info-circle text-blue-500 text-2xl mt-1 flex-shrink-0"></i>
                            <div class="flex flex-column gap-1">
                                <span class="font-bold text-900 text-sm">Registro de Históricos y Próximos Vencimientos</span>
                                <p class="m-0 text-700 text-sm line-height-3">
                                    Los períodos definen la frecuencia de control. Los vencimientos <strong>no se programan a partir de hoy</strong>.
                                    Una vez creado el equipo, ingrese a su <strong>Hoja de Vida</strong> y registre la <strong>última calibración o mantenimiento histórico</strong>. El sistema calculará y agendará automáticamente la próxima fecha en base a dicha intervención.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-3 p-2">
            <p-button label="Cancelar" icon="pi pi-times" severity="secondary" [text]="true" (onClick)="hide()"></p-button>
            <p-button label="Guardar Equipo" icon="pi pi-check" (onClick)="save()" [disabled]="equipmentForm.invalid || loading" [loading]="loading" [rounded]="true"></p-button>
        </div>
    </ng-template>
</p-drawer>
